import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Form from '../views/Form.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Form',
    component: Form,
  },
  {
    path: '/result',
    name: 'Result',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Result.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
